@file:OptIn(org.jetbrains.compose.resources.InternalResourceApi::class)

package materialextension.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi

private object CommonMainDrawable0 {
  public val arrow_back: DrawableResource by 
      lazy { init_arrow_back() }

  public val compose_multiplatform: DrawableResource by 
      lazy { init_compose_multiplatform() }

  public val right_arrow: DrawableResource by 
      lazy { init_right_arrow() }

  public val settings: DrawableResource by 
      lazy { init_settings() }
}

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("arrow_back", CommonMainDrawable0.arrow_back)
  map.put("compose_multiplatform", CommonMainDrawable0.compose_multiplatform)
  map.put("right_arrow", CommonMainDrawable0.right_arrow)
  map.put("settings", CommonMainDrawable0.settings)
}

internal val Res.drawable.arrow_back: DrawableResource
  get() = CommonMainDrawable0.arrow_back

private fun init_arrow_back(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:arrow_back",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.composeapp.generated.resources/drawable/arrow_back.xml", -1, -1),
    )
)

internal val Res.drawable.compose_multiplatform: DrawableResource
  get() = CommonMainDrawable0.compose_multiplatform

private fun init_compose_multiplatform(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:compose_multiplatform",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.composeapp.generated.resources/drawable/compose-multiplatform.xml", -1, -1),
    )
)

internal val Res.drawable.right_arrow: DrawableResource
  get() = CommonMainDrawable0.right_arrow

private fun init_right_arrow(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:right_arrow",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.composeapp.generated.resources/drawable/right_arrow.xml", -1, -1),
    )
)

internal val Res.drawable.settings: DrawableResource
  get() = CommonMainDrawable0.settings

private fun init_settings(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:settings",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/materialextension.composeapp.generated.resources/drawable/settings.xml", -1, -1),
    )
)
